// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"b7a2020b","120":"e4b9dcfb","136":"a6ac1fd3","144":"7dd6d6c9","680":"14954417","776":"193c5156","796":"729c632d","984":"5ad03a00"}[chunkId] + ".chunk.js";
};